import { CareerPathway } from '@cpd-app/generated';

import { createReducer, on } from '@ngrx/store';
import {
  clearPathway,
  getPathway,
  getPathwayFailure,
  getPathwaySuccess
} from './pathway.actions';

export interface PathwayState {
  pathway: CareerPathway;
  loading: boolean;
}

export const initialState: PathwayState = {
  pathway: undefined,
  loading: false
};

export const reducer = createReducer(
  initialState,

  on(getPathway, (state) => {
    return { ...state, pathway: undefined, loading: true };
  }),
  on(getPathwaySuccess, (state, { pathway }) => {
    return { ...state, pathway, loading: false };
  }),
  on(getPathwayFailure, () => initialState),
  on(clearPathway, () => initialState)
);
